export default __webpack_public_path__ + "static/media/Ma009-5.a981f0e2.svg";